@if (matFormField) {
    <!-- Labels come from the surrounding app-field; labelDate/labelTime are the placeholders and aria labels -->
    <div [formGroup]="form" class="datetime-fields">
        @if (!hideDate) {
            <mat-form-field [appearance]="appearance" class="date">
                <input
                    (click)="picker.open()"
                    [attr.aria-label]="labelDate"
                    [formControl]="fcDate"
                    [matDatepicker]="picker"
                    [max]="max"
                    [min]="min"
                    matInput
                    placeholder="{{labelDate}}">
                <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        }
        <mat-form-field [appearance]="appearance" class="time">
            <input
                #timeInput
                (click)="timeInput.select()"
                [attr.aria-label]="labelTime"
                [formControl]="fcTime"
                matInput
                placeholder="hh:mm"
                type="text">
        </mat-form-field>
    </div>
} @else if (!matFormField) {
    <div [formGroup]="form" class="d-flex inline-inputs" role="group">
        @if (!hideDate) {
            <input
                (click)="picker.open()"
                [formControl]="fcDate"
                [matDatepicker]="picker"
                [max]="max"
                [min]="min"
                class="col-7"
                matInput
                placeholder="{{labelDate}}">
        }
        <mat-datepicker #picker></mat-datepicker>
        <input
            #timeInput
            (click)="timeInput.select()"
            [formControl]="fcTime"
            class="{{timeClass ?? (hideDate ? 'col-12' : 'col-5')}}"
            matInput
            placeholder="hh:mm"
            type="text">
    </div>
}
